import { Stack, Typography, TypographyTypeMap } from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { JokerChip } from "../../components/chips/JokerChip";
import { selectPlayerById } from "./players.feature";
import { HandycapChip } from "../../components/chips/HandycapChip";

type PlayerProps = {
  id: string;
  round?: number;
  variant?: TypographyTypeMap["props"]["variant"];
};

export const Player = ({ id, round, variant = "inherit" }: PlayerProps) => {
  const player = useAppSelector((state) => selectPlayerById(state, id));

  return (
    <>
      {player ? (
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant={variant}>
            {player.prename} {player.surname}
          </Typography>
          <HandycapChip handycap={player.handycap} />
          {player.joker === round && <JokerChip />}
        </Stack>
      ) : null}
    </>
  );
};
